import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { NotificationService } from '../services/notification.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  baseUrl = `${environment.serviceBaseUrl}`;
  constructor(private notifyService: NotificationService,) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          console.log(error,"errordfsdf")
          

          if (error?.error instanceof ErrorEvent) {
            // client-side 


            if ((error?.url?.includes(this.baseUrl + 'api/lgiindia/partnerportal/orchestration/integration/v1/approveEndorsement/'))) {
              if (error?.status === 0 || error?.status === 504 || error?.error?.message || error?.message || error) {
                const error = 'Please refesh page after 2 min';
                this.notifyService.showSuccess(error, '');
                return throwError(x);
              }
            }

            // if ((error?.url?.includes(this.baseUrl + 'api/lgiindia/partnerportal/policy/motor/v1/gcsyncpolicydata'))){
            //   if(error?.status === 0 || error?.status === 504 || error?.error?.message || error?.message || error){
            //     const error = 'Policy approved, Please refesh page after 2 min';
            //     this.notifyService.showSuccess(error, '');
            //   }
            // }

            if ((error?.url?.includes(this.baseUrl + 'api/lgiindia/partnerportal/orchestration/proposal/v1/calculatePremium'))) {
              if (error?.status === 500 || error?.error?.message || error?.message || error) {
                errorMessage = error?.message;
              }
            }
            else {
              errorMessage = `Technical error. Please try again later or contact administrator.`;
            }
          } else {
            if (error instanceof TypeError) {
              console.log(error,"errorsdsdfsdf");
              // if (request.url?.includes(this.baseUrl + 'api/short/')) {
              //   this.notifyService.showError('Payment link expired, Kindly resend payment link or reinitiate the proposal creation.', '');
              //   return throwError(x);
              // }
              if ((request.url?.includes(this.baseUrl + 'api/lgiindia/partnerportal/payment/gatewayPayU'))) {
                this.notifyService.showError('Payment has already been processed.', '');

                var x = JSON.parse(error?.error)

                return throwError(x.error.errorMessage)
              }
            }
            // server-side error
            if ((error?.url?.includes(this.baseUrl + 'api/lgiindia/partnerportal/orchestration/integration/v1/approveEndorsement/'))) {
              if (error?.status === 0 || error?.status === 504 || error?.error?.message || error?.message || error) {
                const error = 'Please refesh page after 2 min';
                this.notifyService.showSuccess(error, '');
                return throwError(error);
                //  return throwError();
              }
            }

            if ((error?.url?.includes(this.baseUrl + 'api/lgiindia/partnerportal/policy/motor/v1/gcsyncpolicydata'))) {
              if (error?.status === 0 || error?.status === 504 || error?.error?.message || error?.message || error) {
                const error = 'Policy approved, Please refesh page after 2 min';
                this.notifyService.showSuccess(error, '');
              }
            }

            errorMessage = `Technical error. Please try again later or contact administrator.`;
            // errorMessage = `Error Code: ${error?.status}\nMessage: ${error?.message}`;
            if (error?.error == 'Please verify the input details: {} ') {
              errorMessage = error?.error;
            }
          }
          if ((error?.url?.includes(this.baseUrl + 'api/integration/v1/retriggerGCServices/onlinePayment'))) {
            var x = JSON.parse(error?.error)
            return throwError(x.Message);

          }
          if ((error?.url == this.baseUrl + 'api/fire/partnerportal/payment/v1/editPayment/')) {
            var x = JSON.parse(error?.error)
            return throwError(x.error.errorMessage);

          }
          if ((error?.url == this.baseUrl + 'api/fire/partnerportal/payment/v1/payWithPaymentMode')) {
            //var x = JSON.parse(error?.error)
            return throwError(error?.error?.error?.errorMessage);

          }


          if ((error?.url == this.baseUrl + 'api/search/qpp') && (error?.status != 500)) {
            //var x = JSON.parse(error?.error)
            return throwError(error?.error);
          }
          if ((error?.url == this.baseUrl + 'api/customer/v1/searchCustomers') && (error?.status != 500)) {
            return throwError(error?.error);
          }

          if (error?.message != 'Login required') {
            this.notifyService.showError(errorMessage, '');
          }
          return throwError(errorMessage);
        })
      );
  }
}
